export default __webpack_public_path__ + "static/media/Chef-3.29e198dd.jpg";